const ENV_CONFIG = {
    production: {
        palette: 'giddyup',
        label: '',
        badgeClass: '',
        faviconTint: null,
    },
    staging: {
        palette: 'rose',
        label: 'STAGING',
        badgeClass: 'text-red-500',
        faviconTint: '#e11d48',
    },
    qa: {
        palette: 'green',
        label: 'QA',
        badgeClass: 'text-green-500',
        faviconTint: '#16a34a',
    },
    local: {
        palette: 'amber',
        label: 'LOCAL',
        badgeClass: 'text-amber-500',
        faviconTint: '#d97706',
    },
};

const fallback = import.meta.env.PROD ? 'production' : 'local';
const raw = (import.meta.env.VITE_ENVIRONMENT || fallback).toLowerCase();
const environment = raw in ENV_CONFIG ? raw : fallback;
const config = ENV_CONFIG[environment];

export function useEnvironment() {
    return {
        environment,
        envLabel: config.label,
        envPalette: config.palette,
        envBadgeClass: config.badgeClass,
        envFaviconTint: config.faviconTint,
        isProduction: environment === 'production',
    };
}
